import { useState } from "react";

export type ToastType = "success" | "error";
export type Toast = { id: string; message: string; type: ToastType; createdAt: number };

let toastCounter = 0;

const createId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  toastCounter += 1;
  return `${Date.now()}-${toastCounter}`;
};

export default function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = (message: string, type: ToastType) => {
    setToasts((current) => [...current, { id: createId(), message, type, createdAt: Date.now() }]);
  };

  const dismissToast = (id: string) => {
    setToasts((current) => current.filter((toast) => toast.id !== id));
  };

  return { toasts, showToast, dismissToast };
}
